"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericBlockIcon = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var dynamic_1 = require("@vanilla-extract/dynamic");
var block_generic_svg_1 = __importDefault(require("@ClientAssets/icons/block-generic.svg"));
var react_1 = __importDefault(require("react"));
var GenericBlockIcon = function (_a) {
    var _b;
    var className = _a.className, accent = _a.accent;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { style: !!accent ? (0, dynamic_1.assignInlineVars)((_b = {}, _b["--accent-color"] = accent, _b)) : {} },
        react_1.default.createElement(kaleidoscope_1.SVG, { className: className, src: block_generic_svg_1.default })));
};
exports.GenericBlockIcon = GenericBlockIcon;
